import { GeckoBinSize, GeckoComponentRect } from 'types'

import { type MouseState, snapToBins } from './helpers'

export function binAtPointer(
  event: Pick<
    MouseState,
    | 'componentBounds'
    | 'componentDataFrame'
    | 'componentX'
    | 'componentY'
    | 'componentWrapsX'
    | 'componentWrapsY'
  >
): GeckoComponentRect | undefined {
  const bounds = event.componentBounds
  if (!bounds) return undefined
  const binSize =
    event.componentDataFrame?.data.binning.bin_size ?? GeckoBinSize.OneInchBins
  const geometry =
    event.componentDataFrame?.data.geometry ??
    GeckoComponentRect.CreateFromXYs(
      bounds.componentID,
      bounds.start.x.minus(binSize.width.scale(0.5)).toNumber(bounds.x.unit),
      bounds.start.y.minus(binSize.height.scale(0.5)).toNumber(bounds.y.unit),
      bounds.end.x.plus(binSize.width.scale(0.5)).toNumber(bounds.x.unit),
      bounds.end.y.plus(binSize.height.scale(0.5)).toNumber(bounds.y.unit),
      bounds.x.unit,
      bounds.y.unit
    )
  return snapToBins(
    event.componentX,
    event.componentY,
    event.componentX,
    event.componentY,
    event.componentWrapsX,
    event.componentWrapsY,
    bounds,
    binSize,
    geometry
  )
}
